import { generateColumnsDefaultConfiguration } from "../../../../../components/dataGrid/columnHelpers";

export function useTabProfesionalAddProfessionalColumns() {
  const initialColumns = [
    {
      width: 60,
      field: "idHonorarioProfesional",
      headerName: "ID",
    },
    {
      width: 120,
      field: "descripcion",
      headerName: "Descripción",
    },
    {
      width: 120,
      field: "valor",
      headerName: "V. Presencial",
      valueGetter: (valor) => {
        return '$' + parseFloat(valor || 0).toLocaleString('es-AR')
      }
    },
    {
      width: 120,
      field: "valorVirtual",
      headerName: "V. Virtual",
      valueGetter: (valorVirtual) => {
        return '$' + parseFloat(valorVirtual || 0).toLocaleString('es-AR')
      }
    },
    {
      width: 120,
      field: "cambioSonda",
      headerName: "Cbio. Sonda",
      valueGetter: (cambioSonda) => {
        return '$' + parseFloat(cambioSonda || 0).toLocaleString('es-AR')
      }
    },
    {
      width: 120,
      field: "capacitacion",
      headerName: "Capacitación",
      valueGetter: (capacitacion) => {
        return '$' + parseFloat(capacitacion || 0).toLocaleString('es-AR')
      }
    },
    {
      width: 120,
      field: "emergencia",
      headerName: "Urgencia",
      valueGetter: (emergencia) => {
        return '$' + parseFloat(emergencia || 0).toLocaleString('es-AR')
      }
    },
    {
      width: 120,
      field: "extraDuracion",
      headerName: "Ext. Duración",
      valueGetter: (extraDuracion) => {
        return '$' + parseFloat(extraDuracion || 0).toLocaleString('es-AR')
      }
    },
    {
      width: 100,
      field: "valorExtra",
      headerName: "Valor Extra",
      valueGetter: (valorExtra) => {
        return '$' + parseFloat(valorExtra || 0).toLocaleString('es-AR')
      }
    },
  ];

  const columns = generateColumnsDefaultConfiguration(initialColumns, true);

  return columns;
}
